<template>
  <div
    class="ann-dialog-close"
    role="button"
    tabindex="0"
    :aria-label="props.ariaLabel"
    @click="emit('close')"
    @keydown.enter="emit('close')"
    @keydown.space.prevent="emit('close')"
  ></div>
</template>

<script setup>
import { defineEmits, defineProps } from 'vue'

const props = defineProps({
  ariaLabel: {
    type: String,
    default: 'Close',
  },
})

const emit = defineEmits(['close'])
</script>

<style lang="less" scoped>
.ann-dialog-close {
  position: absolute;
  top: var(--ann-close-top);
  right: var(--ann-close-right);
  z-index: 3;
  width: 67px;
  height: 67px;
  background-image: url('~@/assets/imgs/act/ann2026/common/dialog-close.png');
  background-position: center;
  background-size: 67px 67px;
  background-repeat: no-repeat;
}
</style>
